import styled from 'styled-components';

const Label = styled.p`
  :first-child {
    margin-bottom: 5px;
    margin-top: 15px;
  }

  color: ${(props) => (props.error ? props.theme.color.textError : props.theme.color.textLabel)};
  font-size: 18px;
`;

export { Label };
